import React from 'react'

export default function Iframe(props) {
    const {url} = props
    return (
        <iframe src={url + "&rm=minimal"} frameborder="0"></iframe>
    )
}
